export default function(options) {
  if (!options.headers) {
    options.headers = new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    });
  }
   options.credentials = "include";
}
